import { render, staticRenderFns } from "./personal-ranking.vue?vue&type=template&id=1dd7c6ea&scoped=true&"
import script from "./personal-ranking.vue?vue&type=script&lang=js&"
export * from "./personal-ranking.vue?vue&type=script&lang=js&"
import style0 from "./personal-ranking.vue?vue&type=style&index=0&id=1dd7c6ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7c6ea",
  null
  
)

export default component.exports